export const trackEvents = {
  firebase: {
    enabled: true,
    event: true,
    user: true,
    error: false,
  },
  sentry: {
    enabled: false,
    event: false,
    user: false,
    error: false,
  },
  smartLook: {
    enabled: false,
    event: false,
    user: false,
    error: false,
  },
  optimizely: {
    enabled: false,
    event: true,
    user: true,
    error: false,
  },
  kochava: {
    enabled: process.env.NODE_ENV === 'production',
    event: false,
    user: true,
    error: false,
  },
  singular: {
    enabled: true,
    event: true,
    user: true,
    error: false,
  },
  amplitude: {
    enabled: true,
    event: true,
    user: true,
    error: true,
  },
  datadog: {
    enabled: process.env.NODE_ENV === 'production',
    event: true,
    user: true,
    error: true,
  },
};
